// Module
var code = "<div class=\"flexWrapper__headerPanel\"> <organism-page-header-panel page-header-data=\"$ctrl.pageHeaderData\"></organism-page-header-panel> </div> <organism-ssl-wizard-wrapper></organism-ssl-wizard-wrapper> ";
// Exports
module.exports = code;